(function(){
'use strict';
var drawer=document.getElementById('cart-drawer');if(!drawer)return;
var body=document.getElementById('cart-drawer-body');
var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
var cfg=window.PSI_CART_V411||{};
var baseShipping=Number(cfg.shippingCents);if(!isFinite(baseShipping))baseShipping=499;
var freeThreshold=Number(cfg.freeShippingThreshold)||0;
var currency=(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'EUR';
function money(cents){try{return new Intl.NumberFormat(document.documentElement.lang||'it-IT',{style:'currency',currency:currency}).format((Number(cents)||0)/100)}catch(e){return '€ '+((Number(cents)||0)/100).toFixed(2).replace('.',',')}}
function parseMoney(text){var s=String(text||'').replace(/\s/g,'').replace(/[^0-9,.-]/g,'');if(!s)return 0;if(s.indexOf(',')!==-1)s=s.replace(/\./g,'').replace(',','.');var n=parseFloat(s);return isFinite(n)?Math.round(n*100):0}
function qtyValue(el){return Math.max(0,parseInt(el&&el.value,10)||0)}
function rows(){return Array.prototype.slice.call(drawer.querySelectorAll('.cart-item:not(.is-removing)'))}
function localState(){var subtotal=0,count=0;rows().forEach(function(row){var q=row.querySelector('.qty-num'),p=row.querySelector('.cart-item-price');if(!q||!p)return;var qty=qtyValue(q),unit=parseInt(p.dataset.unitPrice,10)||0;count+=qty;subtotal+=unit*qty});return{subtotal:subtotal,count:count}}
function shippingFor(subtotal,count){if(count<=0)return 0;if(freeThreshold>0&&subtotal>=freeThreshold)return 0;return baseShipping}
function setText(selector,value){var el=drawer.querySelector(selector);if(el&&el.textContent!==value)el.textContent=value}
function isOpen(){return drawer.classList.contains('open')||drawer.getAttribute('aria-hidden')==='false'}

/* V411 - barra spedizione gratuita sotto il riepilogo iniziale del carrello. */
function ensureShippingProgress(){
  var bar=drawer.querySelector('.psi-cart-shipping-progress');
  if(bar)return bar;
  var hero=drawer.querySelector('.psi-cart-hero');
  if(!hero)return null;
  bar=document.createElement('section');
  bar.className='psi-cart-shipping-progress';
  bar.setAttribute('aria-label','Stato spedizione gratuita');
  bar.innerHTML='<p class="psi-cart-shipping-progress-text" aria-live="polite"></p><div class="psi-cart-shipping-progress-track" aria-hidden="true"><span class="psi-cart-shipping-progress-fill"></span></div>';
  hero.insertAdjacentElement('afterend',bar);
  return bar
}
function renderShippingProgress(subtotal,count){
  var bar=drawer.querySelector('.psi-cart-shipping-progress');
  if(freeThreshold<=0||count<=0){if(bar)bar.remove();return}
  if(!bar)bar=ensureShippingProgress();
  if(!bar)return;
  var done=subtotal>=freeThreshold;
  var remaining=Math.max(0,freeThreshold-subtotal);
  var pct=Math.max(0,Math.min(100,(subtotal/freeThreshold)*100));
  var text=bar.querySelector('.psi-cart-shipping-progress-text');
  var fill=bar.querySelector('.psi-cart-shipping-progress-fill');
  bar.classList.toggle('is-done',done);
  if(fill)fill.style.width=pct.toFixed(2)+'%';
  if(text){
    text.textContent='';
    if(done){
      text.textContent='✓ Hai ottenuto la spedizione gratuita';
    }else{
      text.appendChild(document.createTextNode('Ti mancano '));
      var amount=document.createElement('strong');
      amount.textContent=money(remaining);
      text.appendChild(amount);
      text.appendChild(document.createTextNode(' per la spedizione gratuita'))
    }
  }
}

function renderTotals(subtotal,count,writeSubtotal){var shipping=shippingFor(subtotal,count),total=subtotal+shipping;if(writeSubtotal)setText('#cart-subtotal',money(subtotal));setText('[data-psi-cart-shipping]',shipping===0?'Gratis':money(shipping));setText('[data-psi-cart-total]',money(total));setText('[data-psi-cart-hero-total]',money(total));setText('[data-psi-cart-item-label]',count===1?'articolo':'articoli');var c=drawer.querySelector('#cart-count-drawer');if(c&&String(c.textContent).trim()!==String(count))c.textContent=String(count);var hc=document.getElementById('cart-count');if(hc&&String(hc.textContent).trim()!==String(count)){hc.textContent=String(count);hc.classList.toggle('hidden',count===0)}renderShippingProgress(subtotal,count)}
function renderLocal(){var s=localState();renderTotals(s.subtotal,s.count,true)}
function renderFromSubtotal(){var sub=drawer.querySelector('#cart-subtotal');if(!sub)return renderLocal();var s=localState();renderTotals(parseMoney(sub.textContent),s.count,false)}
function syncQtyActions(){drawer.querySelectorAll('.psi-cart-qty-dec').forEach(function(btn){var wrap=btn.closest('.cart-item-qty'),input=wrap&&wrap.querySelector('.qty-num'),q=qtyValue(input),remove=q<=1;btn.dataset.action=remove?'remove':'decrease';btn.setAttribute('aria-label',remove?'Rimuovi articolo':'Diminuisci quantità')})}
function micro(fn){if(typeof queueMicrotask==='function')queueMicrotask(fn);else Promise.resolve().then(fn)}

/* V411 - opzioni variante separate: Taglia e Colore su righe autonome. */
var variantRequest=0,variantQueued=false;
function optionKind(name){
  var n=String(name||'').toLowerCase();
  if(n.indexOf('taglia')!==-1||n.indexOf('size')!==-1||n.indexOf('misura')!==-1)return 'size';
  if(n.indexOf('colore')!==-1||n.indexOf('color')!==-1)return 'color';
  return ''
}
function variantRows(item){
  var opts=item&&Array.isArray(item.options_with_values)?item.options_with_values:[];
  var size=null,color=null,other=[];
  opts.forEach(function(opt){
    if(!opt||!opt.value||opt.value==='Default Title')return;
    var kind=optionKind(opt.name);
    if(kind==='size'&&!size)size=opt;
    else if(kind==='color'&&!color)color=opt;
    else other.push(opt)
  });
  var out=[];
  if(size)out.push(['Taglia',size.value]);
  if(color)out.push(['Colore',color.value]);
  other.forEach(function(opt){out.push([opt.name||'Opzione',opt.value])});
  return out
}
function renderVariantOptions(cart){
  var map=Object.create(null);
  var items=cart&&Array.isArray(cart.items)?cart.items:[];
  items.forEach(function(item){if(item&&item.key)map[String(item.key)]=item});
  rows().forEach(function(row){
    var box=row.querySelector('.cart-item-variant');
    if(!box)return;
    var item=map[String(row.getAttribute('data-key')||'')];
    if(!item)return;
    var lines=variantRows(item);
    if(!lines.length)return;
    box.textContent='';
    lines.forEach(function(line){
      var r=document.createElement('div');r.className='psi-cart-variant-row';
      var label=document.createElement('span');label.className='psi-cart-variant-label';label.textContent=line[0];
      var value=document.createElement('span');value.className='psi-cart-variant-value';value.textContent=line[1];
      r.appendChild(label);r.appendChild(value);box.appendChild(r)
    })
  })
}
function loadVariantOptions(){
  if(!isOpen())return;
  var request=++variantRequest;
  fetch(root+'cart.js',{headers:{Accept:'application/json'},credentials:'same-origin',cache:'no-store'})
    .then(function(r){if(!r.ok)throw new Error('cart');return r.json()})
    .then(function(cart){if(request!==variantRequest||!isOpen())return;renderVariantOptions(cart)})
    .catch(function(){})
}
function scheduleVariantOptions(){
  if(variantQueued)return;
  variantQueued=true;
  micro(function(){variantQueued=false;loadVariantOptions()})
}

drawer.addEventListener('click',function(e){var btn=e.target&&e.target.closest?e.target.closest('.qty-btn'):null;if(!btn)return;micro(function(){syncQtyActions();renderLocal()})});
drawer.addEventListener('change',function(e){if(!e.target.classList||!e.target.classList.contains('qty-num'))return;micro(function(){syncQtyActions();renderLocal()})});
drawer.addEventListener('keyup',function(e){if(e.key!=='Enter'||!e.target.classList||!e.target.classList.contains('qty-num'))return;micro(function(){syncQtyActions();renderLocal()})});
drawer.addEventListener('submit',function(e){var form=e.target&&e.target.closest?e.target.closest('[data-psi-cart-search]'):null;if(!form)return;var input=form.querySelector('.psi-cart-search-input');if(!input||!input.value.trim()){e.preventDefault();if(input)input.focus()}});

var observedSubtotal=null;
var subtotalObserver=new MutationObserver(function(){micro(renderFromSubtotal)});
function attachSubtotalObserver(){var sub=drawer.querySelector('#cart-subtotal');if(sub===observedSubtotal)return;subtotalObserver.disconnect();observedSubtotal=sub;if(sub)subtotalObserver.observe(sub,{childList:true,characterData:true,subtree:true})}
if(body)new MutationObserver(function(){micro(function(){attachSubtotalObserver();syncQtyActions();renderFromSubtotal();scheduleVariantOptions()})}).observe(body,{childList:true});
new MutationObserver(function(){if(isOpen()){renderFromSubtotal();scheduleVariantOptions()}}).observe(drawer,{attributes:true,attributeFilter:['class','aria-hidden']});
attachSubtotalObserver();syncQtyActions();renderFromSubtotal();if(isOpen())scheduleVariantOptions();
}());
